<script>
export default {
  props: {
    msgid: String,
    msgstr: String
  },
  template: '<span></span>',
  created: function () {
    var self = this
    self.$parent.$emit('translation-custom', self.msgid, self.msgstr)
  }
}
</script>


// WEBPACK FOOTER //
// Translation.vue?25532fbe